import { pick } from 'lodash';
import { ShapeState3D } from '../../cross-team-shared/annotation/shared/state/shape-state';
import { isOrthographicShape3D } from '../../cross-team-shared/state/shape.state';
import {
  ContentUtils,
  PartiallyTransformedShape,
} from '../../team-apis/content/content-utils';
import { PointCloudShapeType } from '../../team-apis/otterdam/answers/point-cloud-answer';
import { Point3D } from '../../team-apis/otterdam/answers/shape-typings';
import {
  calcPositionRotationScale,
  locationStateExternal,
} from '../state/cuboid-location-state-3d';
import { isCuboidState3D } from '../state/cuboid-state-3d';

class ContentUtils3D implements ContentUtils<Point3D, PointCloudShapeType> {
  addKeyLocationsToShapeExternal(
    shapeExternal: PartiallyTransformedShape<Point3D, PointCloudShapeType>,
  ): ShapeState3D {
    if (!isOrthographicShape3D(shapeExternal)) {
      return {
        ...shapeExternal,
        key_locations: shapeExternal.key_locations.map((location) => ({
          ...location,
          points: [],
          ...calcPositionRotationScale(location.points),
        })),
      };
    }
    return shapeExternal;
  }

  convertShapeStateToAnswer(shapeState: ShapeState3D) {
    let keyLocations = shapeState.key_locations;

    if (isCuboidState3D(shapeState)) {
      keyLocations = shapeState.key_locations.map(locationStateExternal);
    }
    return {
      ...pick(
        shapeState,
        'type',
        'index',
        'tags',
        'dynamic_tags',
        'linkedShapeId',
      ),
      key_locations: keyLocations,
    };
  }
}

export const contentUtils3D = new ContentUtils3D();
